import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectNewsItem } from '../selectors/news-item.selector';
import { newsItemActions } from '../actions/news-item.actions';
import { NewsItemValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class NewsItemFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly newsItem$ = this.store.select(selectNewsItem);
    readonly newsItemNonNullable$ = this.store.select(selectNewsItem).pipe(filter((newsItem) => newsItem !== null));

    readonly newsItem = this.store.selectSignal(selectNewsItem);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getNewsItem(id: string): void {
        this.store.dispatch(newsItemActions.getNewsItem({ id }));
    }

    createNewsItem(value: NewsItemValue): void {
        this.store.dispatch(newsItemActions.createNewsItem({ value }));
    }

    updateNewsItem(id: string, value: NewsItemValue): void {
        this.store.dispatch(newsItemActions.updateNewsItem({ id, value }));
    }

    deleteNewsItem(id: string): void {
        this.store.dispatch(newsItemActions.deleteNewsItem({ id }));
    }

    clear(): void {
        this.store.dispatch(newsItemActions.clear());
    }
}
